import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Container } from "semantic-ui-react";
import Navigation from "./Navigation";
import ModelConfigList from "./ModelConfigList";
import ModelConfigForm from "./ModelConfigForm";
import UsageLogList from "./UsageLogList";
import UsageLogDetail from "./UsageLogDetail";

export default function LlmLog() {
  return (
    <Container fluid style={{ padding: "20px" }}>
      <Navigation />
      <Routes>
        <Route path="/" element={<Navigate to="model-configs" replace />} />
        <Route path="model-configs" element={<ModelConfigList />} />
        <Route path="model-configs/create" element={<ModelConfigForm />} />
        <Route path="model-configs/edit/:id" element={<ModelConfigForm />} />
        <Route path="usage-logs" element={<UsageLogList />} />
        <Route path="usage-logs/:id" element={<UsageLogDetail />} />
      </Routes>
    </Container>
  );
}